import { ArrowLeft } from "lucide-react";
import type { JSX, ReactNode } from "react";
import { Link } from "react-router";

import { cn } from "../../lib/cn.js";
import { Button } from "../ui/button.js";

export interface PageHeaderProps {
  title: ReactNode;
  description?: ReactNode;
  backTo?: string;
  backLabel?: string;
  actions?: ReactNode;
  className?: string;
}

export function PageHeader({
  title,
  description,
  backTo,
  backLabel = "Back",
  actions,
  className,
}: PageHeaderProps): JSX.Element {
  return (
    <header
      className={cn("flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between", className)}
    >
      <div className="flex min-w-0 items-start gap-3">
        {backTo ? (
          <Button asChild variant="ghost" size="icon" className="mt-0.5">
            <Link to={backTo} aria-label={backLabel}>
              <ArrowLeft className="size-6" />
            </Link>
          </Button>
        ) : null}
        <div className="min-w-0 space-y-1">
          <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
          {description ? <p className="text-sm text-muted-foreground">{description}</p> : null}
        </div>
      </div>
      {actions ? (
        <div className="flex flex-wrap items-center gap-2 sm:shrink-0 sm:justify-end">{actions}</div>
      ) : null}
    </header>
  );
}
